import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';

export default function Topbar() {
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();
  const go = (path) => (e) => { e.preventDefault(); navigate(path); };

  return (
    <div className="topbar">
      {/* Text links — these correctly flip with RTL/LTR */}
      <div className="topbar-right">
        <a href="/about"   onClick={go('/about')}>{t('topbar.about')}</a>
        <a href="/contact" onClick={go('/contact')}>{t('topbar.contact')}</a>
        <a href="/donate"  onClick={go('/donate')}>{t('topbar.donate')}</a>
      </div>

      {/*
        Lang buttons: always physically on the LEFT side, never move.
        dir="ltr" — forces this container to always be LTR internally
        style margin-left:auto — pushes to physical left in flex row
        (in RTL flex, "left" side is the end, so we use margin-inline-start:auto
         which is always the start of the flex row regardless of direction)
      */}
      <div
        className="topbar-left"
        dir="ltr"
        style={{ marginInlineStart: 'auto' }}
      >
        <button className={`lang-btn${lang === 'ar' ? ' active' : ''}`} onClick={() => setLang('ar')}>AR</button>
        <button className={`lang-btn${lang === 'en' ? ' active' : ''}`} onClick={() => setLang('en')}>EN</button>
        <button className={`lang-btn${lang === 'ur' ? ' active' : ''}`} onClick={() => setLang('ur')}>UR</button>
      </div>
    </div>
  );
}